import OBTTooltip from './OBTTooltip';

export default OBTTooltip;